import utils from "./utils";
import bridgeApis from "./bridge/bridgeApis";

function restoreAppHeight() {
  const root = document.documentElement;
  root.style.minHeight = "";
  root.style.overflow = "";
  root.classList.remove("fo-app-height-fix");
}

// 注意, 该方法在componentDidMount里最后执行, 且必须是await所有数据加载后执行
// 如果有另外更新数据的情况, 请另外单独调用
function setAppHeightOfScrollBody() {
  if (!utils.isFoApp()) {
    return;
  }
  setTimeout(() => {
    const scrollBody = document.querySelector(
      ".appLayout-body>.appLayout-body-inner"
    );
    if (scrollBody) {
      const root = document.documentElement;

      // 必须先将高度还原, 否则后面拿取  scrollBody.scrollHeight 会以root的minHeight为准
      // root.style.minHeight = "";
      // root.style.overflow = "";

      const height = Math.ceil(scrollBody.offsetHeight);

      console.log("changed height: ", height);

      root.style.minHeight = `${height}px`;
      root.style.overflow = "auto";
      root.classList.add("fo-app-height-fix");

      // 通过bridge告知客户端, 页面高度发生了变化, 让webview去调整页面高度
      bridgeApis.bodyHeightChanged({ height });
    }
  }, 0);
}

window.setAppHeightOfScrollBody = setAppHeightOfScrollBody;

export { restoreAppHeight, setAppHeightOfScrollBody };



// WEBPACK FOOTER //
// ./src/utils/appWebviewHeightFix.js